module.exports = __webpack_public_path__ + "static/img/bot_suc_bg.d922848.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/activity/images/bot_suc_bg.png
// module id = lojC
// module chunks = 1